import {
    Divider,
    Picker,
    Tabbar,
    TabbarItem,
    Popup,
    Field,
    Radio,
    RadioGroup,
    Button,
    Form,
    Uploader,
    Icon,
    ActionSheet,
    Grid,
    GridItem,
    Image as VanImage,
    SubmitBar,
    NavBar,
    List,
    Cell,
    Dialog,
    CellGroup,
    Overlay, Calendar, Notify, SwipeCell, ImagePreview
} from "vant";
import {createApp} from "vue";
import App from "./App.vue";
import router from "./router";

createApp(App)
    .use(router)
    .use(Tabbar)
    .use(TabbarItem)
    .use(Divider)
    .use(Picker)
    .use(Popup)
    .use(Field)
    .use(Radio)
    .use(RadioGroup)
    .use(Button)
    .use(Form)
    .use(Uploader)
    .use(Icon)
    .use(ActionSheet)
    .use(Grid)
    .use(GridItem)
    .use(VanImage)
    .use(SubmitBar)
    .use(NavBar)
    .use(List)
    .use(Cell)
    .use(Dialog)
    .use(CellGroup)
    .use(Overlay)
    .use(Calendar)
    .use(Notify)
    .use(SwipeCell)
    .use(ImagePreview)
    .mount("#app");
